"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importStar(require("react"));
const TranslationProvider_1 = require("../../provider/TranslationProvider");
const Text = ({ translationKey, value = {}, extra }) => {
    const { translations } = (0, TranslationProvider_1.useTranslationContext)();
    const { locale = typeof window !== 'undefined' ? localStorage?.getItem('locale') : 'en_US' } = extra || {};
    const shouldFallback = !translations?.[translationKey]?.[locale];
    const displayString = translations?.[translationKey]?.[shouldFallback ? 'en_US' : locale]?.replace(/\{([^}]+)\}/g, (match, key) => {
        if (value.hasOwnProperty(key)) {
            return value[key];
        }
        return match;
    });
    return react_1.default.createElement(react_1.Fragment, null, displayString);
};
exports.default = Text;
//# sourceMappingURL=index.js.map